import { render, staticRenderFns } from "./InformacionPago.vue?vue&type=template&id=0350782f&scoped=true"
import script from "./InformacionPago.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacionPago.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InformacionPago.vue?vue&type=style&index=0&id=0350782f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350782f",
  null
  
)

export default component.exports